<template>
  <div id="app">
    <Head />
    <!-- <Header :urlLogout="urlLogout" :redirectUrl="redirectUrl" /> -->
     <Header :headTitle="'在线预约系统'" />
    <div class="index_content container" 
         v-bind:style="{backgroundImage:'url(' + bg + ')',
         backgroundRepeat:'no-repeat',
         backgroundSize:'100% 100%'}">
         
      <div class="foot">
        <!--
        <a href="change_exhibition.html">
          <i class="iconfont icon-yuyue" ></i>
          <div>参观预约</div>
        </a>-->
        <a @click="goChangeExhibition()" href="javascript:return false;">
          <i class="iconfont icon-yuyue" ></i>
          <div>参观预约</div>
        </a>
         <!--
        <a href="visit.html?type=2">
          <i class="iconfont icon-chaxun"></i>
          <div>查档预约</div>
        </a>
        -->
         <a @click="showAlert()" href="javascript:return false;">
          <i class="iconfont icon-chaxun"></i>
          <div>查档预约</div>
        </a>
        <a href="search_select_page.html">
          <i class="iconfont icon-tianjiarenyuan"></i>
          <div>我的预约</div>
        </a>
        <!-- <a href="del_reserve_page.html">
          <div><i class="el-icon-circle-close"></i></div>
          <div>取消预约</div>
        </a> -->
        <!-- <a @click="messageTips">
          <div><i class="el-icon-circle-close"></i></div>
          <div>取消预约</div>
        </a> -->
      </div>
    </div>
    <Footer />
    <!-- <FixedMenu /> -->
  </div>
</template>

<script>
import Head from '../../components/common/head.vue'
import Header from '../../components/common/header.vue'
import Footer from '../../components/common/footer.vue'
// import { getUrlKey } from '@/utils/geturlkey'

export default {
  name: 'App',
  components: {
    Head,
    Header,
    Footer
  },
  methods: {
    messageTips() {
      this.$notify({
          title: '该功能暂未开放！',
          // message: '这是一条带有偏移的提示消息',
          offset: 65,
          customClass:'notify-tips'
      });
    },

    showAlert(){
      alert('温馨提示:查档暂无需预约，欢迎到馆查阅');
   },
  goChangeExhibition()
  {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const formattedDate = `${year}-${month}-${day}`;
    window.location.href = 'change_exhibition.html?dateTime=' + formattedDate;

  }
  },
  data(){
    return{
      bg: require('@/assets/background.jpg')
    }
  },
  created(){
    
  }

  
}
</script>

<style lang="scss" scoped>
// 四个按钮的整体位置
  .foot
  {
    margin-top: 5.5rem;
  }
  .index_content
  {
    /* text-align: center; */
    /* font-size: 0.5rem; */
    display: flex;
    flex-wrap:wrap;
    justify-content:space-evenly;
    align-content:space-evenly;
    background: linear-gradient(to bottom right, #dbeaff, #c2dcff);
  }
   // 四个图标大小和位置
  .index_content iconfont
  {
    font-size: 0.75rem;
    margin-top: 0.2rem;
   
  }
  .index_content a
  {
    background: #CBE8F0;
    color: #1963AC;
    // 四个图标的字体大小
    font-size: 0.22rem;
    display: inline-block;
    // 蓝色按钮间隔
    margin: 0.17rem;
    // 蓝色按钮大小
    width: 1.1rem;
    height: 1.1rem;
    text-align: center;
    // line-height: 2rem;
    text-decoration: none;
    // 棱角平缓
    border-radius: 0.2rem;
    // box-shadow: 0.1rem 0.1rem 0.1rem #ccc;
    // 四个图片阴影颜色
    // box-shadow: 0.1rem 0.1rem 0.1rem #fff;
  }
  .index_content a div
  {
    margin-bottom: 0.05rem;
  }
</style>
<style>
  .notify-tips
  {
    background: #dbeaff!important;
    opacity: 0.6;
  }
</style>
